import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Entrega',
  [ORDER_METHODS.pickup]: 'Recogida',
  [ORDER_METHODS.on_site]: 'Pedidos en mesa',
};
